import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import AppList from './AppList';
import AppDetails from './AppDetails';
import GraphsPage from './pages/GraphsPage';
import ScatterPlotPage from './pages/ScatterPlotPage';
import Login from './components/Login';
import { supabase } from './supabaseClient';

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
  }, []);

  return (
    <div className="App bg-background min-h-screen flex flex-col">
      <Header session={session} />
      <main className="container mx-auto p-4 mt-8 flex-grow">
        <Routes>
          <Route path="/login" element={!session ? <Login /> : <Navigate to="/" />} />
          <Route path="/" element={session ? <AppList /> : <Navigate to="/login" />} />
          <Route path="/app/:appName" element={session ? <AppDetails /> : <Navigate to="/login" />} />
          <Route path="/graphs" element={session ? <GraphsPage /> : <Navigate to="/login" />} />
          <Route path="/scatter" element={session ? <ScatterPlotPage /> : <Navigate to="/login" />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
